export default {
      id: "save-guide-usage",
      viewBox: "0 0 20 18",
      url: "/" + "sprite.svg#save-guide",
      toString: function () {
        return this.url;
      }
    }